var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form-control', {
    attrs: {
      "field": _vm.field
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('v-checkbox', {
          attrs: {
            "readonly": _vm.readonly,
            "value": api.getValue(),
            "data": _vm.data,
            "caption": _vm.caption,
            "label": _vm.label,
            "error": api.getTouched() ? api.getError() : undefined
          },
          on: {
            "input": api.setValue,
            "blur": api.setTouched
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function(label) {
              return [_vm._t("label")]
            }
          }])
        })]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-820453bc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/appComponents/components/Form/FormCheckbox.vue
// module id = 693
// module chunks = 0